<template>
  <section class="auth-bg">
    <div class="auth-card">
      <div class="card-accent-bar"></div>
      <div class="card-inner">
        <!-- Logo -->
        <div class="text-center mb-4">
          <router-link to="/home" class="logo-link">
            <div class="logo-ring">
              <img src="@/assets/images/logo.png" alt="Buzz Booking" height="58" />
            </div>
          </router-link>
          <h3 class="brand-name">Buzz Booking</h3>
          <span class="brand-badge">Dashboard Login</span>
        </div>

        <BuzzLoginAdmin />
      </div>
    </div>
  </section>
</template>

<script>
import BuzzLoginAdmin from "@/components/BuzzLoginAdmin.vue";

export default {
  name: "DashboardLoginView",
  components: {
    BuzzLoginAdmin,
  },
};
</script>

<style scoped>
/* ── Background ─────────────────────────────────── */
.auth-bg {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;
  background-color: #363a48;
  background-image:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.06) 0px,
      rgba(255, 255, 255, 0.06) 1px,
      transparent 1px,
      transparent 22px
    ),
    repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.06) 0px,
      rgba(255, 255, 255, 0.06) 1px,
      transparent 1px,
      transparent 22px
    );
}

.auth-bg::before,
.auth-bg::after {
  content: '';
  position: absolute;
  pointer-events: none;
}

.auth-bg::before {
  inset: 0;
  background: radial-gradient(ellipse 80% 80% at 50% 50%, transparent 40%, rgba(0, 0, 0, 0.45) 100%);
}

.auth-bg::after {
  width: 700px;
  height: 700px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(239, 203, 1, 0.13) 0%, transparent 65%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ── Card ───────────────────────────────────────── */
.auth-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 1.375rem;
  overflow: hidden;
  box-shadow:
    0 40px 90px rgba(0, 0, 0, 0.55),
    0 10px 28px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(239, 203, 1, 0.13);
}

.card-accent-bar {
  height: 5px;
  background: linear-gradient(90deg, #b89600 0%, #efcb01 35%, #fff38c 65%, #efcb01 100%);
}

.card-inner {
  padding: 2rem 2.25rem 2rem;
}

/* ── Logo ───────────────────────────────────────── */
.logo-link {
  display: inline-block;
  text-decoration: none;
}

.logo-ring {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: radial-gradient(circle at 40% 40%, rgba(239, 203, 1, 0.13) 0%, rgba(239, 203, 1, 0.04) 60%, transparent 100%);
  border: 2px solid rgba(239, 203, 1, 0.28);
  margin-bottom: 0.5rem;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.logo-ring:hover {
  border-color: rgba(239, 203, 1, 0.55);
  box-shadow: 0 0 28px rgba(239, 203, 1, 0.14);
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #18100a;
  letter-spacing: -0.025em;
  margin: 0 0 0.3rem;
}

.brand-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #9a8555;
  background: rgba(239, 203, 1, 0.1);
  border: 1px solid rgba(239, 203, 1, 0.22);
  border-radius: 999px;
  padding: 0.15rem 0.75rem;
}

</style>
